import { IntlShape } from "react-intl";
import { messages } from "./taxConfiguration.messages";
import { FormConfiguration } from "../shared/crud/form";
import { TaxConfigurationEntity } from "../shared/api/taxConfiguration/domain/taxConfiguration.entity";

export function buildSchema(intl: IntlShape) {
  return {
    $schema: "http://json-schema.org/draft-07/schema#",
    required: ["cityTaxType"],
    type: "object",
    properties: {
      vatPercentage: {
        type: "number",
      },
      cityTaxType: {
        oneOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
          {
            type: "null",
          },
        ],
        enum: ["PER_PERSON_PER_NIGHT", 4, "ROOM_STAY_PERCENTAGE_PARAMS", 5, "BALEARIC_PARAMS", 6],
      },
    },
    dependencies: {
      cityTaxType: {
        oneOf: [
          {
            properties: {
              cityTaxType: {
                oneOf: [
                  {
                    type: "string",
                  },
                  {
                    type: "integer",
                  },
                ],
                enum: ["PER_PERSON_PER_NIGHT", 4],
              },
              amountPerNight: {
                title: intl.formatMessage(messages.amountPerNightLabel),
                type: "number",
                minimum: 0,
              },
              minimumAge: {
                title: intl.formatMessage(messages.minimumAgeLabel),
                type: "integer",
                minimum: 0,
              },
            },
            required: ["amountPerNight", "minimumAge"],
          },
          {
            properties: {
              cityTaxType: {
                oneOf: [
                  {
                    type: "string",
                  },
                  {
                    type: "integer",
                  },
                ],
                enum: ["ROOM_STAY_PERCENTAGE", 5],
              },
              percentage: {
                title: intl.formatMessage(messages.percentageLabel),
                type: "number",
                minimum: 0,
                maximum: 1,
              },
            },
            required: ["percentage"],
          },
          {
            properties: {
              cityTaxType: {
                oneOf: [
                  {
                    type: "string",
                  },
                  {
                    type: "integer",
                  },
                ],
                enum: ["BALEARIC", 6],
              },
              amountPerNight: {
                title: intl.formatMessage(messages.amountPerNightLabel),
                type: "number",
                minimum: 0,
              },
            },
            required: ["amountPerNight"],
          },
        ],
      },
    },
  };
}

export function buildFormConfiguration(): FormConfiguration<TaxConfigurationEntity> {
  return {
    __fieldOrder: ["*"],
    __useProtoStyleArrays: true,
    vatPercentage: {
      placeholder: messages.vatPercentagePlaceholder,
      messages: {
        label: messages.vatPercentageLabel,
      },
    },
    cityTaxType: {
      messages: {
        label: messages.cityTaxTypeLabel,
      },
      placeholder: messages.cityTaxTypePlaceholder,
      enumLabels: [
        messages.cityTaxTypePerPersonNight,
        messages.cityTaxTypeRoomStayPercentage,
        messages.cityTaxTypeBalearic,
      ],
    },
  };
}
